import services from './../../../services/service'; // Service Class
// import SecondHeader from './../Second-Header/index.vue'; // Second Header
// import Sidebar from './../Sidebar/index.vue'; // Sidebar
// import MainFooter from './../Main-Footer/index.vue'; // Main Footer
// import SearchBar from '../SearchBar.vue'; // Search Bar

let service = new services();
export default {
    name: 'CNInsuranceSystem',
    data () {
        return {
            
        }
    },
    components: {
        //'component-header': MainHeader,
        //'component-footer': MainFooter,
     },
    methods: {
       
    },

    created: function(){
    },
}


// WEBPACK FOOTER //
// ./src/components/CNInsuranceSystem/Template/script.js